// extracted by mini-css-extract-plugin
export default {"submissionSuccess":"submissionSuccess__SubmissionSuccess__Ot0XZ","thankyou":"thankyou__SubmissionSuccess__Ot0XZ"};